<mat-dialog-content>
  <h1 class="font-semibold text-2xl pb-3">
    Crear Usuario Interno
  </h1>
  <form [formGroup]="form" class="flex flex-col gap-6 p-3">
    <div class="my-form">
      <label for="name" class="text-gray-500">Nombre</label>
      <input
        id="name"
        type="text"
        formControlName="name"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
        [ngClass]="{'border-red-500': f['name'].invalid && (f['name'].touched || f['name'].dirty)}"
      />
      @if (f['name'].touched && f['name'].errors?.['required']) {
        <p class="text-red-500 text-sm mt-1">
          El nombre es requerido.
        </p>
      }
    </div>
    <div>
      <label for="email" class="text-gray-500">Correo Electrónico</label>
      <input
        [disabled]="true"
        id="email"
        formControlName="email"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400"
        [ngClass]="{'border-red-500':f['email'].invalid && (f['email'].touched || f['name'].dirty)}"
      />
      @if (f['email'].touched && f['email'].errors?.['required']) {
        <p class="text-red-500 text-sm mt-1">
          El correo Electrónico es requerido.
        </p>
      } @else if (f['email'].touched && f['email'].errors?.['email']) {
        <p class="text-red-500 text-sm mt-1">
          El correo Electrónico es inválido.
        </p>
      }
    </div>
    <div>
      <label for="phone" class="text-gray-500">Número de Teléfono</label>
      <input
        [disabled]="true"
        id="phone"
        type="text"
        placeholder="+59398XXXXXXX o 098XXXXXXX"
        formControlName="phone"
        class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400"
        [ngClass]="{'border-red-500':f['phone'].invalid && (f['phone'].touched || f['phone'].dirty)}"
      />
      @if (f['phone'].touched && f['phone'].errors?.['required']) {
        <p class="text-red-500 text-sm mt-1">
          El Número de Teléfono es requerido.
        </p>
      } @else if (f['phone'].touched && (f['phone'].errors?.['maxlength'] || f['phone'].errors?.['minlength'])) {
        <p class="text-red-500 text-sm mt-1">
          El Número de Teléfono es inválido.
        </p>
      } @else if (f['phone'].touched && (f['phone'].errors?.['pattern'])) {
        <p class="text-red-500 text-sm mt-1">
          El Número de Teléfono es inválido.
        </p>
      }
    </div>
    <div>
      <label for="role" class="text-gray-500">Roles</label>
      <div class="w-full py-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400"
           [ngClass]="{'border-red-500': f['role'].invalid && (f['role'].touched || f['role'].dirty)}">
        <p-multi-select id="role" fluid [options]="roleList"
                        [style]="{'border': '0', 'outline': 'none', 'background': 'transparent', 'width': '100%'}"
                        scrollHeight="250px" optionLabel="code"
                        appendTo="body"
                        formControlName="role"
                        display="chip">
        </p-multi-select>
      </div>
      @if (f['role'].touched && f['role'].errors?.['required']) {
        <p class="text-red-500 text-sm mt-1">
          El rol es requerido.
        </p>
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
          (click)="close(false)">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
  <button
    class="rounded-3xl flex items-center gap-2 bg-orange-500 text-white py-2 px-4 cursor-pointer hover:bg-orange-600 disabled:bg-orange-200 disabled:cursor-not-allowed"
    (click)="save()" [disabled]="form.invalid">
    <span class="text-base">Guardar</span>
    <i class="fi-rr-disk text-base flex"></i>
  </button>
</mat-dialog-actions>
